export default __webpack_public_path__ + "static/media/ic-fuite eau.6cb8e374.svg";